const Insight = () => {
    return (
        <svg
            width="20"
            height="21"
            viewBox="0 0 20 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 2.79309C10.4142 2.79309 10.75 3.12888 10.75 3.54309V4.04309C10.75 4.4573 10.4142 4.79309 10 4.79309C9.58579 4.79309 9.25 4.4573 9.25 4.04309V3.54309C9.25 3.12888 9.58579 2.79309 10 2.79309Z"
                fill="#00527C"
            />
            <path
                d="M5.58059 4.95965C5.2877 4.66676 4.81283 4.66676 4.51993 4.95965C4.22704 5.25254 4.22704 5.72742 4.51993 6.02031L4.87349 6.37386C5.16638 6.66676 5.64125 6.66676 5.93415 6.37386C6.22704 6.08097 6.22704 5.6061 5.93415 5.3132L5.58059 4.95965Z"
                fill="#00527C"
            />
            <path
                d="M2 10.5431C2 10.1289 2.33579 9.79309 2.75 9.79309H3.25C3.66421 9.79309 4 10.1289 4 10.5431C4 10.9573 3.66421 11.2931 3.25 11.2931H2.75C2.33579 11.2931 2 10.9573 2 10.5431Z"
                fill="#00527C"
            />
            <path
                d="M16 10.5431C16 10.1289 16.3358 9.79309 16.75 9.79309H17.25C17.6642 9.79309 18 10.1289 18 10.5431C18 10.9573 17.6642 11.2931 17.25 11.2931H16.75C16.3358 11.2931 16 10.9573 16 10.5431Z"
                fill="#00527C"
            />
            <path
                d="M15.6569 6.19707C15.9497 5.90418 15.9497 5.4293 15.6569 5.13641C15.364 4.84352 14.8891 4.84352 14.5962 5.13641L14.2426 5.48996C13.9497 5.78286 13.9497 6.25773 14.2426 6.55062C14.5355 6.84352 15.0104 6.84352 15.3033 6.55062L15.6569 6.19707Z"
                fill="#00527C"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.4737 6.79133C8.42123 4.84381 11.5788 4.84381 13.5263 6.79133C14.4753 7.74028 14.9869 8.89451 14.9869 10.0886C14.9869 11.2827 14.4753 12.4369 13.5263 13.3859C13.5085 13.4037 13.4905 13.4213 13.4725 13.4387C12.9997 13.894 12.75 14.3051 12.75 14.6795V15.793C12.75 17.1737 11.6307 18.293 10.25 18.293H9.75001C8.3693 18.293 7.25001 17.1737 7.25001 15.793V14.6795C7.25001 14.3051 7.00032 13.894 6.52755 13.4387C6.50949 13.4213 6.49154 13.4037 6.4737 13.3859C5.52476 12.4369 5.01306 11.2827 5.01306 10.0886C5.01306 8.89451 5.52476 7.74028 6.4737 6.79133ZM12.4656 7.85199C11.1039 6.49025 8.8961 6.49025 7.53436 7.85199C6.82868 8.55767 6.51306 9.34308 6.51306 10.0886C6.51306 10.8341 6.82868 11.6195 7.53436 12.3252C7.54555 12.3364 7.55678 12.3474 7.56805 12.3583C7.93411 12.7108 8.35586 13.1937 8.58345 13.7931H11.4166C11.6442 13.1937 12.0659 12.7108 12.432 12.3583C12.4432 12.3474 12.4545 12.3364 12.4656 12.3252C13.1713 11.6195 13.4869 10.8341 13.4869 10.0886C13.4869 9.34308 13.1713 8.55767 12.4656 7.85199ZM11.25 15.2931H8.75001V15.793C8.75001 16.3453 9.19772 16.793 9.75001 16.793H10.25C10.8023 16.793 11.25 16.3453 11.25 15.793V15.2931Z"
                fill="#00527C"
            />
        </svg>
    )
}

export default Insight
